import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import arrow from './ProfilePictureImages/arrow.svg';
import eyes from './ProfilePictureImages/eyes.svg';
import logo from './ProfilePictureImages/logo.png';
import spark from './ProfilePictureImages/spark.svg';

const CANVAS_W = 640;
const CANVAS_H = 780;

export const ProfilePictureShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H);

  return (
    <section
      ref={sectionRef}
      className='relative flex h-full w-full justify-center overflow-hidden bg-warning-50'
    >
      <div style={wrapperStyle}>
        <div style={canvasStyle}>
          <h1
            className='absolute m-0 text-display-xl font-semibold text-gray-700'
            style={{ top: 48, left: 10, width: 560 }}
          >
            A picture is worth 1000 words...
          </h1>

          <p
            className='absolute m-0 text-xl font-normal text-gray-600'
            style={{ top: 200, left: 10, width: 540 }}
          >
            Volunteers with a profile picture connect with<br/>more organizations!
          </p>

          <img
            src={logo}
            alt=''
            className='absolute'
            style={{ top: 295, left: 70, width: 500, height: 438 }}
          />

          <img
            src={arrow}
            alt=''
            className='absolute'
            style={{ top: 265, left: 20, width: 140, height: 139 }}
          />

          <img
            src={eyes}
            alt=''
            className='absolute'
            style={{ top: 400, left: 545, width: 78, height: 60 }}
          />

          <img
            src={spark}
            alt=''
            className='absolute'
            style={{ top: 263, left: 551, width: 56, height: 52 }}
          />
        </div>
      </div>
    </section>
  );
};
